module.exports = __webpack_public_path__ + "static/media/tankTrailer_orange.1d6ce4f9.svg";